import Chip from '@mui/material/Chip';
import { VerificationStatusDto, CompanyScoringState, KosmosReportSnapshotDto } from 'models/dtoTypes';

export default function VerificationStatusChip({
  verificationStatus,
  isDissolved,
  scoringState,
  reportSnapshot,
}: {
  verificationStatus?: VerificationStatusDto,
  isDissolved?: boolean,
  scoringState?: CompanyScoringState,
  reportSnapshot?: KosmosReportSnapshotDto,
}) {
  if (isDissolved) {
    return <Chip label="Dissolved" color="error" />;
  }

  const lowerStatus = verificationStatus?.toString()?.toLowerCase() || '';
  switch(lowerStatus) {
    case 'pending': return <Chip label="Pending" color="warning" />;
    case 'notfound': return <Chip label="Not found" color="info" />;
    case 'verifyerror': return <Chip label="Error" color="error" />;
    case 'multipleresults': return <Chip label="Multiple Results" color="info" />;
    case 'verified': {
      switch(scoringState) {
        case 'NotStarted': return <Chip label="Verified" color="primary" />;
        case 'InProgress': return <Chip label="In Progress" color="info" />;
        case 'Error': return <Chip label="Score Error" color="error" />;
        case 'Completed':
          // if there is no active snapshot, not scored by this organisation
          if (!reportSnapshot) {
            return <Chip label="Verified" color="primary" />;
          } else {
            return <Chip label="Complete" color="success" />;
          }
        default: return <Chip label="Verified" color="primary" />;
      }
    }
    default: return <></>;
  }
}
